<template>
  <v-container fluid class="mx-auto">
    <!-- Main Visual & Catchphrase -->
    <v-row justify="center">
      <!-- <v-col cols="12" md="6">
        <v-card elevation="2" height="350">
          <v-img src="../assets/ck_screenshot.png" cover></v-img>
        </v-card>
      </v-col> -->

      <v-col cols="12" md="8">
        <v-card elevation="2" height="550" class="d-flex flex-column">
          <v-img src="../assets/ck_screenshot.png" height="300" cover></v-img>
          <v-card-title> See yourself in a whole new world! </v-card-title>
          <v-spacer />
          <v-card-text>
            Discover a world where YOU are the star! Customize exciting games,
            gift a personalized experience, and share your unique adventures
            with just a URL. Play anywhere, anytime, on any device.
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
              large
              color="primary"
              variant="outlined"
              to="/games/custom-keeper/play"
            >
              Play a Demo
            </v-btn>

            <v-btn large color="secondary" variant="outlined" to="/catalog">
              Show Games Catalogue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Carousel for additional game images or screenshots -->
    <!-- <v-row justify="center" class="my-4">
      <v-carousel>
        <v-carousel-item v-for="(item, i) in items" :key="i">
          <v-img :src="item.src"></v-img>
        </v-carousel-item>
      </v-carousel>
    </v-row> -->
  </v-container>
</template>

<script>
export default {
  name: "LandingPage",
  data() {
    return {
      items: [
        { src: "path-to-image1.jpg" },
        { src: "path-to-image2.jpg" },
        // Add more image paths as required
      ],
    };
  },
};
</script>
